// prettier-ignore
import { DefaultUrlSerializer } from '@angular/router';

export const BusinessRoutes = {
  'end-user': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId',
  'end-user-acd-details':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/call-queues/agent/:agentId',
  'end-user-acd-queues': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/call-queues',
  'end-user-base-route': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId',
  'end-user-call-barring':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/call-barring',
  'end-user-call-center': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/call-center',
  'end-user-call-center-agent':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/call-center/:callCenterId/agent/:agentId',
  'end-user-call-center-agents':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/call-center/agents',
  'end-user-call-center-live-monitoring':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/call-center/live-monitoring',
  'end-user-call-center-phone-book':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/call-center/phone-book',
  'end-user-call-center-reports':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/call-center/reports',
  'end-user-call-details':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/call-details',
  'end-user-call-logs': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/call-logs',
  'end-user-conference': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/conference',
  'end-user-devices': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/devices',
  'end-user-distribute-function-keys':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/devices/:deviceId/functionKeys/distributeSettings',
  'end-user-documentation':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/documentation',
  'end-user-feature-distribution':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/feature/:featureId/distributeSettings',
  'end-user-features': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/feature',
  'end-user-function-keys':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/devices/:deviceId/functionKeys',
  'end-user-holiday-lists':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/holiday-lists',
  'end-user-import': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/import',
  'end-user-ipfilter': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/ipfilter',
  'end-user-messages': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/messages',
  'end-user-ms365-presence':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/ms365-presence',
  'end-user-overview': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/overview',
  'end-user-permissions': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/permissions',
  'end-user-personalization':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/personalization',
  'end-user-phone-book': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/phone-book',
  'end-user-phone-book-contacts':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/phone-book/contacts',
  'end-user-phone-book-export-import':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/phone-book/export-import',
  'end-user-phone-numbers':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/assigned-phone-numbers',
  'end-user-rich-presence-profiles':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/rich-presence/profiles',
  'end-user-rich-presence-profile':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/rich-presence/profiles/:profileId',
  'end-user-registrations': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/registrations',
  'end-user-soft-clients':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/soft-clients',
  'end-user-speed-dials':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/phone-book/speed-dials',
  'end-user-time-table': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/:userId/time-tables',
  enterprise: '/reseller/:serviceProviderId/enterprises/:enterpriseId',
  'enterprise-ab-routing': '/reseller/:serviceProviderId/enterprises/:enterpriseId/ab-routing',
  'enterprise-ab-routing-export-import':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/ab-routing/export-import',
  'enterprise-ab-routing-routes': '/reseller/:serviceProviderId/enterprises/:enterpriseId/ab-routing/routes',
  'enterprise-acd-queue': '/reseller/:serviceProviderId/enterprises/:enterpriseId/acd-queues/:queueId',
  'enterprise-acd-queue-agents':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/acd-queues/:queueId/agents',
  'enterprise-acd-queue-announcements':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/acd-queues/:queueId/announcements',
  'enterprise-acd-queue-assigned-numbers':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/acd-queues/:queueId/assigned-numbers',
  'enterprise-acd-queue-call-log':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/acd-queues/:queueId/callLog',
  'enterprise-acd-queue-call-recording':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/acd-queues/:queueId/call-recording',
  'enterprise-acd-queue-contact-groups':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/acd-queues/:queueId/contactGroups',
  'enterprise-acd-queue-route-config':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/acd-queues/:queueId/routeConfig',
  'enterprise-acd-queue-settings':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/acd-queues/:queueId/settings',
  'enterprise-acd-queue-voice-mail':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/acd-queues/:queueId/voiceMail',
  'enterprise-acd-queues': '/reseller/:serviceProviderId/enterprises/:enterpriseId/acd-queues',
  'enterprise-administrator':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/administrators',
  'enterprise-admins': '/reseller/:serviceProviderId/enterprises/:enterpriseId/admins',
  'enterprise-announcements': '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/announcements',
  'enterprise-assign-users-to-room':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/rooms/:id/assign-users-to-room',
  'enterprise-base-route': '/reseller/:serviceProviderId/enterprises/:enterpriseId',
  'enterprise-calendar': '/reseller/:serviceProviderId/enterprises/:enterpriseId/calendar',
  'enterprise-call-barring': '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/call-barring',
  'enterprise-call-center': '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center',
  'enterprise-call-center-agents':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/agents',
  'enterprise-call-center-announcements':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/announcements',
  'enterprise-call-center-parent': '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center',
  'enterprise-call-center-phone-book':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/phone-book',
  'enterprise-call-center-queue':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/:callCenterId/queues/:queueId',
  'enterprise-call-center-queue-agents':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/:callCenterId/queues/:queueId/agents',
  'enterprise-call-center-queue-announcements':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/:callCenterId/queues/:queueId/announcements',
  'enterprise-call-center-queue-assigned-numbers':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/:callCenterId/queues/:queueId/assigned-numbers',
  'enterprise-call-center-queue-call-log':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/:callCenterId/queues/:queueId/call-log',
  'enterprise-call-center-queue-call-recording':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/:callCenterId/queues/:queueId/call-recording',
  'enterprise-call-center-queue-route-config':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/:callCenterId/queues/:queueId/route-config',
  'enterprise-call-center-queue-settings':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/:callCenterId/queues/:queueId/settings',
  'enterprise-call-center-queue-voice-mail':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/:callCenterId/queues/:queueId/voice-mail',
  'enterprise-call-center-queues':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/queues',
  'enterprise-call-center-reports':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/reports',
  'enterprise-call-center-settings':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/settings',
  'enterprise-call-center-skills-states':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/call-center/skills-states',
  'enterprise-conference': '/reseller/:serviceProviderId/enterprises/:enterpriseId/conference',
  'enterprise-documentation': '/reseller/:serviceProviderId/enterprises/:enterpriseId/documentation',
  'enterprise-holiday-lists': '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/holiday-lists',
  'enterprise-holiday-lists-details':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/holiday-lists/:holidayListId',
  'enterprise-ipfilter': '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/ipfilter',
  'enterprise-ivr': '/reseller/:serviceProviderId/enterprises/:enterpriseId/ivr/:ivrId',
  'enterprise-ivr-block': '/reseller/:serviceProviderId/enterprises/:enterpriseId/ivr/:ivrId/blocks/:blockId',
  'enterprise-ivrs': '/reseller/:serviceProviderId/enterprises/:enterpriseId/ivr',
  'enterprise-journal': '/reseller/:serviceProviderId/enterprises/:enterpriseId/journal',
  'enterprise-journal-call-details':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/journal/call-details',
  'enterprise-journal-history': '/reseller/:serviceProviderId/enterprises/:enterpriseId/journal/history',
  'enterprise-meetings': '/reseller/:serviceProviderId/enterprises/:enterpriseId/meetings',
  'enterprise-messages': '/reseller/:serviceProviderId/enterprises/:enterpriseId/messages',
  'enterprise-microsoft-teams': '/reseller/:serviceProviderId/enterprises/:enterpriseId/microsoft-teams',
  'enterprise-multiline-devices': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/adapters',
  'enterprise-options': '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/options',
  'enterprise-phone-book': '/reseller/:serviceProviderId/enterprises/:enterpriseId/phone-book',
  'enterprise-phone-book-contacts':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/phone-book/contacts',
  'enterprise-phone-book-export-import':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/phone-book/export-import',
  'enterprise-phone-numbers': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/phone-numbers',
  'enterprise-presence-information':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/presence',
  'enterprise-ms365-presence':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/ms365-presence',
  'enterprise-device-attributes':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/device-settings',
  'enterprise-device-attribute-settings':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/device-settings/:manufacturer/:attribute',
  'enterprise-room': '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/rooms/:id',
  'enterprise-rooms': '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/rooms',
  'enterprise-routing-group-call-barring':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/routing-groups/:routingGroupId/call-barring',
  'enterprise-routing-groups':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/routing-groups',
  'enterprise-screen-number':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/screen-numbers/:screenNumberId',
  'enterprise-screen-number-add-to-user':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/screen-numbers/:screenNumberId/add-to-user',
  'enterprise-screen-number-assign-as-main':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/screen-numbers/:screenNumberId/assign-as-main',
  'enterprise-screen-number-remove-from-user':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/screen-numbers/:screenNumberId/remove-from-user',
  'enterprise-screen-numbers':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/screen-numbers',
  'enterprise-settings': '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings',
  'enterprise-settings-customer':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/enterprise',
  'enterprise-site': '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/sites/:siteName',
  'enterprise-site-assign-users-to-location':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/sites/:siteName/locations/:locationGroupId/assign-users-to-location',
  'enterprise-site-location':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/sites/:siteName/locations/:locationGroupId',
  'enterprise-site-locations':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/sites/:siteName/locations',
  'enterprise-site-services':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/sites/:siteName/services',
  'enterprise-site-settings':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/sites/:siteName/settings',
  'enterprise-sites': '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/sites',
  'enterprise-soft-clients': '/reseller/:serviceProviderId/enterprises/:enterpriseId/soft-clients',
  'enterprise-speed-dials': '/reseller/:serviceProviderId/enterprises/:enterpriseId/phone-book/speed-dials',
  'enterprise-time-table': '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/time-tables',
  'enterprise-sbc': '/reseller/:serviceProviderId/enterprises/:enterpriseId/settings/sbc',
  'enterprise-trunk': '/reseller/:serviceProviderId/enterprises/:enterpriseId/trunks/:trunkId',
  'enterprise-trunk-call-barring':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/trunks/:trunkId/call-barring',
  'enterprise-trunk-features':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/trunks/:trunkId/features',
  'enterprise-trunk-number-range-features':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/trunks/:trunkId/number-ranges/:numberRangeId/features',
  'enterprise-trunk-number-ranges':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/trunks/:trunkId/number-ranges',
  'enterprise-trunk-settings':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/trunks/:trunkId/settings',
  'enterprise-trunk-users': '/reseller/:serviceProviderId/enterprises/:enterpriseId/trunks/:trunkId/users',
  'enterprise-trunks': '/reseller/:serviceProviderId/enterprises/:enterpriseId/trunks',
  'enterprise-users': '/reseller/:serviceProviderId/enterprises/:enterpriseId/users',
  'enterprise-users-mac-addresses-export-import':
    '/reseller/:serviceProviderId/enterprises/:enterpriseId/users/adapters/mac-addresses',
  'search-results-for-enterprise': '/reseller/:serviceProviderId/enterprises/:enterpriseId/search',
  'search-results-for-reseller': '/reseller/:serviceProviderId/search',
  'service-provider-administrator': '/reseller/:serviceProviderId/administrators',
  'service-provider-allowed-devices': '/reseller/:serviceProviderId/allowed-devices',
  'service-provider-base-route': '/reseller/:serviceProviderId',
  'service-provider-call-barring': '/reseller/:serviceProviderId/call-barring',
  'service-provider-document': '/reseller/:serviceProviderId/documentation/:downloadId',
  'service-provider-documentation': '/reseller/:serviceProviderId/documentation',
  'service-provider-enterprises': '/reseller/:serviceProviderId/enterprises',
  'service-provider-files': '/reseller/:serviceProviderId/files',
  'service-provider-ipfilter': '/reseller/:serviceProviderId/ipfilter',
  'service-provider-journal-call-details': '/reseller/:serviceProviderId/journal/call-details',
  'service-provider-journal-history': '/reseller/:serviceProviderId/journal/history',
  'service-provider-notifications': '/reseller/:serviceProviderId/notifications',
  'service-provider-notification': '/reseller/:serviceProviderId/notifications/:notificationId',
  'service-provider-product-options': '/reseller/:serviceProviderId/product-options',
  'service-provider-feature-profiles': '/reseller/:serviceProviderId/feature-profiles',
  'service-provider-feature-profile': '/reseller/:serviceProviderId/feature-profiles/:featureProfileId',
  'service-provider-feature-profiles-comparison':
    '/reseller/:serviceProviderId/feature-profiles/compare/features',
  'service-provider-roles': '/reseller/:serviceProviderId/roles',
  'service-provider-role': '/reseller/:serviceProviderId/roles/:roleId',
  'service-provider-roles-comparison': '/reseller/:serviceProviderId/roles/compare/permissions',
  'service-provider-registration-summary': '/reseller/:serviceProviderId/registration-summary',
  'service-provider-soft-clients': '/reseller/:serviceProviderId/soft-clients',
  'service-provider-soft-client': '/reseller/:serviceProviderId/soft-clients/:downloadId',
  'service-provider-device-attributes': '/reseller/:serviceProviderId/device-attributes',
  'system-admin-base-route': '',
  'system-admin-allowed-devices': '/allowed-devices',
  'system-admin-device': '/device',
  'system-admin-device-firmwares': '/device',
  'system-admin-device-manufacturers': '/device/manufacturers',
  'system-admin-device-models': '/device/models',
  'system-admin-device-series': '/device/series',
  'system-admin-document': '/documents/:downloadId',
  'system-admin-documents': '/documents',
  'system-admin-downloads': '/downloads',
  'system-admin-download': '/downloads/:downloadId',
  'system-admin-files': '/files',
  'system-admin-notifications': '/notifications',
  'system-admin-notification': '/notifications/:notificationId',
  'system-admin-system-info': '/system-info',
  'system-admin-soft-client': '/soft-clients/:downloadId',
  'system-admin-soft-clients': '/soft-clients',
};

/**
 * Find the business route that matches the given url.
 * @param url Url with filled path parameters.
 * @return Route name or null if no route matches the given url.
 */
export function findRouteName(url: string): string | null {
  let name: string | null = null;

  const pathWithoutMatrixParameters = new DefaultUrlSerializer()
    .parse(url)
    .root.children.primary?.segments.map((segment) => segment.path)
    .join('/');

  const cleanPath = `/${pathWithoutMatrixParameters}`;

  const route = Object.entries(BusinessRoutes)
    .filter(([, route]) => {
      // Replace path parameters with ".*?" so we can test the route using a regex
      const regex = new RegExp(route.replace(/([/]):.*?([/]|$)/g, '$1.*?$2'));
      return regex.test(cleanPath);
    })
    .sort(([, a], [, b]) => a.split('/').length - b.split('/').length)
    .pop();

  if (route != null) {
    name = route[0];
  }

  return name;
}
